/* SAMED · inyecta el botón "Ver producto" en cada tarjeta de producto
   y es robusto ante el re-render AJAX de filtros/orden de Dawn. */
(function () {
  function addButtons(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.samed-ver-producto')) return;
      var link = card.querySelector('a.full-unstyled-link');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      var info = card.querySelector('.card-information') || card.querySelector('.card__information');
      if (!info) return;
      var a = document.createElement('a');
      a.href = href;
      a.className = 'samed-ver-producto button button--secondary';
      a.setAttribute('tabindex', '-1');
      a.textContent = 'Ver producto';
      info.appendChild(a);
    });
  }
  function init() {
    addButtons(document);
    var target = document.getElementById('ProductGridContainer') || document.querySelector('main') || document.body;
    if (target && window.MutationObserver) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { addButtons(document); break; }
        }
      });
      obs.observe(target, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
